import type { CSSProperties, FC } from 'react';
import { NeonIllustration } from '@ps-refarch-ux/neon';
import type { NeonIllustrationsProps } from './types';

const StylesForIllustration: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
export const NeonIllustrations: FC<NeonIllustrationsProps> = ({
  dataBackground,
  dataIllustration,
  containerClassName,
  columnClassName,
  illustrationStyle,
}: NeonIllustrationsProps) => {
  return (
    <div className={containerClassName}>
      <div className={columnClassName} style={StylesForIllustration}>
        {dataIllustration && (
          <NeonIllustration
            dataBackground={dataBackground}
            dataIllustration={dataIllustration}
            style={illustrationStyle}
          />
        )}
      </div>
    </div>
  );
};
